/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import './ContentEditable.css';

import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { setIsChangeByUser } from '../../../app/EditorSlice';
import { debounce } from "lodash";



export default React.forwardRef(function LexicalContentEditable({
  className,
  placeholder,
  placeholderClassName,
}, ref) {
  const dispatch = useDispatch();

  const handleEditorChange = () => {
    updateState();
  };

  const updateState = React.useCallback(
    debounce(() => {
      dispatch(setIsChangeByUser(true));
    }, 200),
    [dispatch]
  );

  return (
    <ContentEditable
      ref={ref}
      className={className ?? 'ContentEditable__root'}
      aria-placeholder={placeholder}
      onKeyDown={() => handleEditorChange()}
      placeholder={
        <div className={placeholderClassName ?? 'ContentEditable__placeholder'}>
          {placeholder}
        </div>
      }
    />
  );
});
